import { render, staticRenderFns } from "./EditProduto.vue?vue&type=template&id=43395560&"
import script from "./EditProduto.vue?vue&type=script&lang=js&"
export * from "./EditProduto.vue?vue&type=script&lang=js&"
import style0 from "./EditProduto.vue?vue&type=style&index=0&id=43395560&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports